import { render, staticRenderFns } from "./CourseManager.vue?vue&type=template&id=55be068f&scoped=true&"
import script from "./CourseManager.vue?vue&type=script&lang=js&"
export * from "./CourseManager.vue?vue&type=script&lang=js&"
import style0 from "./CourseManager.vue?vue&type=style&index=0&id=55be068f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be068f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VOverlay,VRow,VSheet,VSpacer,VTextField})
